import { useEffect, useState } from "react";
import Homepage from "./components/Home/Homepage";
import Header from "./components/utilities/Header";
import Footer from "./components/utilities/Footer";
import Contact from "./components/static/Contact";
import Blog from "./components/static/Blog";
import AboutUs from "./components/static/AboutUs";
import Policies from "./components/static/Policies";
import Events from "./components/events/Events";
import Services from "./components/static/Services";
import ScrollToTop from "./components/utilities/ScrollToTop";
import Products from "./components/products/Products";
import ProductPage from "./components/products/ProductPage";
import Cart from "./components/store/Cart";
import SignIn from "./components/auth/SignIn";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Profile from "./components/auth/Profile";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./App.css";
import PageNotFound from "./components/utilities/PageNotFound";
import { Navigate } from "react-router-dom";
import useCart from "./components/hooks/useCart";
import axios from "axios";
import OrderHistory from "./components/orders/OrderHistory";
import AddProduct from "./components/products/AddProduct";
import OrderSuccess from "./components/orders/OrderSuccess";
import { usePromiseTracker } from "react-promise-tracker";
import EventPage from "./components/events/EventPage";
import AddEvent from "./components/events/AddEvent";

function App() {
  const [user, loading] = useAuthState(auth);
  const { promiseInProgress } = usePromiseTracker();
  const [userInfo, setUserInfo] = useState({});
  const [cartItemsCount, setCartItemsCount] = useState("");
  const [checkOut, setCheckOut] = useState(true);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [events, setEvents] = useState([]);
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [updateInventory, setUpdateInventory] = useState(false);
  const [searchedProducts, setSearchedProducts] = useState([]);
  const [orderSuccess, setOrderSuccess] = useState({
    flag: false,
    data: "",
  });

  const {
    cartItems,
    handleCartUpdate,
    setCartItems,
    coupons,
    reachedMax,
    setReachedMax,
  } = useCart(user, userInfo);

  useEffect(() => {
    if (user) {
      console.log("user", user);
    } else {
      console.log("No User found");
    }
  }, [user]);

  // Getting userInfo from db when logged in
  useEffect(() => {
    const uid = user?.uid;
    if (uid) {
      // console.log("uid App", uid);
      axios
        .post(`${process.env.REACT_APP_BACKEND_LINK}/getuserinfo`, { uid })
        .then((res) => {
          console.log("fetched", res);
          setUserInfo(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // else {
    //   console.log("No User id found");
    // }
  }, [user, auth, orderSuccess]);

  // Getting cartItems from db or localstorage
  useEffect(() => {
    // console.log("Main Entrancce", userInfo);
    if (Object.keys(userInfo).length > 0) {
      setCartItems(userInfo.cartItems);
    } else {
      const localCartItems = localStorage.getItem("ambhosCartItems");
      let parsedData;
      try {
        parsedData = JSON.parse(localCartItems);
      } catch (error) {
        // Handle the error if the storedData is not a valid JSON string
        console.error("Error parsing JSON:", error);
        parsedData = null; // Set parsedData to a fallback value or null
      }
      if (parsedData === null) {
        setCartItems([]);
      } else {
        setCartItems(parsedData);
      }
    }
  }, [userInfo]);

  // Getting count of cartItems
  useEffect(() => {
    let count = 0;
    // console.log(cartItems);
    if (cartItems?.length > 0) {
      cartItems?.map((cartItem) => {
        count = count + cartItem.quantity;
        return;
      });
    }
    // console.log("count", count);
    setCartItemsCount(count);
  }, [cartItems]);

  // Handling sign out feature
  const handleAuth = () => {
    setUserInfo({});
    setCartItems([]);
    setCartItemsCount(0);
    signOut(auth)
      .then(() => console.log("Signed Out Successfully"))
      .catch((err) => console.log("SignOut Error: ", err));
  };

  // Getting Categories and Products from db
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_LINK}/getcategories`)
      .then((data) => setCategories(data.data))
      .catch((err) => console.log(err));

    axios
      .get(`${process.env.REACT_APP_BACKEND_LINK}/api/getproducts`)
      .then((data) => setProducts(data.data))
      .catch((err) => console.log(err));
  }, [updateInventory]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_LINK}/getevents`)
      .then((data) => setEvents(data.data))
      .catch((err) => console.log(err));
  }, []);

  // Filtering products on the basis of category and storing in state object
  useEffect(() => {
    if (products.length !== 0) {
      const newCategoryProducts = categories.map((category) => {
        const filteredProducts = products.filter(
          (product) => product.category === category.name
        );
        const categoryName = category.name;
        return { [categoryName]: filteredProducts };
      });
      const categoryObject = newCategoryProducts?.reduce((obj, item) => {
        if (item && typeof item === "object") {
          const [key] = Object.keys(item);
          obj[key] = item[key];
        }
        return obj;
      }, {});
      setCategoryProducts(categoryObject);
    }
  }, [products, categories]);

  // function to filter products of specific category to display in store
  const filterCategoryProducts = (categoryName) => {
    if (Object.keys(categoryProducts).length !== 0) {
      const requiredCategory = Object.keys(categoryProducts).filter(
        (item) => item === categoryName
      );

      const filteredProducts = requiredCategory.map(
        (item) => categoryProducts[item]
      );
      return filteredProducts[0];
    }
  };

  // useEffect(() => {
  //   console.log("CP", categoryProducts);
  // }, [categoryProducts]);

  useEffect(() => {
    if (!checkOut) {
      setInterval(() => {
        setCheckOut(true);
      }, 1000);
    }
  }, [checkOut]);

  return (
    <Router>
      <ScrollToTop />
      <Header
        user={user}
        handleAuth={handleAuth}
        cartItemsCount={cartItemsCount}
        searchedProducts={searchedProducts}
        setSearchedProducts={setSearchedProducts}
      />
      <div
        className={
          promiseInProgress === true
            ? "text-gray-700"
            : "mx-auto px-4 md:px-8 text-gray-700"
          // : "max-w-7xl mx-auto px-4 md:px-8 text-gray-600"
        }
      >
        <Routes>
          <Route
            path="/"
            exact
            element={
              <Homepage
                categories={categories}
                products={products}
                events={events}
                handleCartUpdate={handleCartUpdate}
                filterCategoryProducts={filterCategoryProducts}
                categoryProducts={categoryProducts}
                reachedMax={reachedMax}
                setReachedMax={setReachedMax}
              />
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route
            path="/addproduct"
            element={
              userInfo?.email === "admin@test.com" ? (
                <AddProduct />
              ) : (
                <PageNotFound />
              )
            }
          />
          <Route
            path="/addevent"
            element={
              userInfo?.email === "admin@test.com" ? (
                <AddEvent />
              ) : (
                <PageNotFound />
              )
            }
          />
          <Route path="/policies" element={<Policies />} />
          <Route path="/events" element={<Events events={events} />} />
          <Route path="/services" element={<Services />} />
          <Route
            path="/cart"
            element={
              checkOut ? (
                <Cart
                  cartItemsCount={cartItemsCount}
                  user={user}
                  cartItems={cartItems}
                  setCartItems={setCartItems}
                  coupons={coupons}
                  userInfo={userInfo}
                  setCheckOut={setCheckOut}
                  products={products}
                  orderSuccess={orderSuccess}
                  setOrderSuccess={setOrderSuccess}
                  handleCartUpdate={handleCartUpdate}
                  reachedMax={reachedMax}
                  setReachedMax={setReachedMax}
                  updateInventory={updateInventory}
                  setUpdateInventory={setUpdateInventory}
                />
              ) : (
                <Navigate to="/signIn" />
              )
            }
          />
          <Route
            path="/profile"
            element={<Profile user={user} userInfo={userInfo} />}
          />
          <Route
            path="/orderhistory"
            element={<OrderHistory user={user} userInfo={userInfo} />}
          />
          <Route
            path="/signIn"
            element={
              user ? (
                <Navigate to="/" />
              ) : (
                <SignIn
                  user={user}
                  setUserInfo={setUserInfo}
                  cartItems={cartItems}
                />
              )
            }
          />
          <Route
            path="/store/products"
            element={
              <Products
                handleCartUpdate={handleCartUpdate}
                categoryProducts={categoryProducts}
                reachedMax={reachedMax}
                setReachedMax={setReachedMax}
                searchedProducts={searchedProducts}
              />
            }
          />
          <Route
            path="/store/products/:id"
            element={
              <ProductPage
                handleCartUpdate={handleCartUpdate}
                products={products}
                coupons={coupons}
                reachedMax={reachedMax}
                setReachedMax={setReachedMax}
              />
            }
          />
          <Route
            path="/ordersuccess/:id"
            element={
              <OrderSuccess
                orderSuccess={orderSuccess}
                setOrderSuccess={setOrderSuccess}
              />
            }
          />
          <Route path="/events/:id" element={<EventPage events={events} />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
